import React, { useState } from "react";
import { api } from "./api";

// Scanner items cannot be deleted (the next scan brings them back): they can be hidden from the public.
// Items that exist only because of a user report (no scanner source, no snapshots) can be deleted.
export default function ItemModeration({ item, snapshotsCount, styles, onChanged }) {
  const [reason, setReason] = useState("");
  const [msg, setMsg] = useState("");
  const reportedOnly = !!item.reported_only && !item.source_id && !snapshotsCount;
  const hide = async (hidden) => {
    try { await api.hideItem(item.id, hidden, reason); setMsg(hidden ? "Hidden from the public." : "Visible to the public again."); onChanged && onChanged(); }
    catch (ex) { setMsg("Error: " + ex.message); }
  };
  const del = async () => {
    const typed = window.prompt('This permanently deletes the item and its user reports. Type DELETE to confirm.');
    if (typed !== "DELETE") { setMsg("Not deleted."); return; }
    try { await api.deleteItem(item.id, typed, reason); window.location.assign("/admin/items"); }
    catch (ex) { setMsg("Error: " + ex.message); }
  };
  return (
    <div style={styles.card} data-testid="item-moderation">
      <h3 style={{ marginTop: 0 }}>Moderation</h3>
      <div style={styles.row}>
        <label className="hs-label" htmlFor="im-reason" style={{ marginBottom: 0 }}>Reason (audited)</label>
        <input id="im-reason" style={{ ...styles.input, minWidth: 240 }} value={reason} onChange={(e) => setReason(e.target.value)} />
        {item.public_hidden
          ? <button type="button" data-testid="item-unhide" style={styles.btnDim} onClick={() => hide(false)}>Show to the public again</button>
          : <button type="button" data-testid="item-hide" style={styles.btnDim} onClick={() => hide(true)}>Hide from public</button>}
        {reportedOnly
          ? <button type="button" data-testid="item-delete" style={styles.btnDim} onClick={del}>Delete permanently</button>
          : <span style={{ fontSize: 12, color: "var(--hs-text-muted)" }} data-testid="item-delete-unavailable">Found by a scanner: cannot be deleted (it would come back on the next scan).</span>}
      </div>
      {item.public_hidden && <div style={{ fontSize: 12 }} className="hs-badge hs-badge-warning" data-testid="item-hidden-badge">Hidden from public</div>}
      {msg && <div style={{ fontSize: 12, color: "var(--hs-text-muted)", marginTop: 6 }}>{msg}</div>}
    </div>
  );
}
